/*
 |--------------------------------------------------------------------------
 | Questions / state.js
 |--------------------------------------------------------------------------
 */

export default {
    boatType: null,
    boatMaterial: null,
    sailFrequency: null,
    country: null,
    localProducts: {}
}
